import React, { Component } from "react";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Split from "grommet/components/Split";
import Box from "grommet/components/Box";
import { Doughnut } from "react-chartjs-2";
import moment from "moment";
import StatBox from "../../components/StatBox";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import DateRange from "../../components/dateRange";
import stacked100 from "chartjs-plugin-stacked100";
import { flow } from "lodash";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Loader from "../../components/LoaderOverlay";

const DoughnutNum = styled.h4`
  font-size: 25px !important;
  color: #696969;
  letter-spacing: 0;
  margin: 0;
  font-weight: bold !important;
  padding: 0;
  line-height: 16px !important;
`;

const DoughnutCopy = styled.p`
  color: #696969;
  font-size: 12px !important;
  line-height: 10px !important;
  margin: 5px 0 0 0 !important;
  padding: 0 !important;
`;

const DoughnutLabel = styled.div`
  text-align: center;
  position: absolute;
  padding: 55px 35px 35px 35px;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

const ChartTitle = styled.div`
  text-transform: uppercase;
  margin-bottom: 25px;
  font-family: "Open Sans", sans-serif;
  font-weight: semibold;
  font-size: 20px !important;
  color: #696969;
  font-weight: 500;
  line-height: 20px !important;
`;

class Dashboard extends Component {
  setChartData() {
    this.setState({
      healthData: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "July",
          "Aug",
          "Sept",
          "Oct",
          "Nov"
        ], // responsible for how many bars are gonna show on the chart
        datasets: [
          {
            label: "Poor Health",
            data: [20, 35, 23, 43, 20, 33, 53, 23, 23, 43, 54, 25],
            backgroundColor: "#FE876E"
          },
          {
            label: "Moderate Health",
            data: [10, 34, 23, 43, 20, 53, 23, 13, 63, 23, 44, 25],
            backgroundColor: "#FAE17E"
          },
          {
            label: "Good Health",
            data: [20, 34, 53, 23, 40, 23, 43, 23, 53, 23, 44, 55],
            backgroundColor: "#45EAAF"
          }
        ]
      },
      healthOptions: {
        legend: {
          display: false
        },
        plugins: {
          stacked100: { enable: true }
        },
        tooltips: {
          xAlign: "center",
          yAlign: "top",
          displayColors: false,
          borderColor: "#E6F2F9",
          borderWidth: 1,
          backgroundColor: "white",
          titleFontColor: "#696969",
          titleSpacing: 10,
          titleFontSize: 15,
          bodyFontColor: "#696969",
          bodyFontSize: 11,
          xPadding: 20,
          yPadding: 20
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                fontSize: 10,
                fontColor: "#696969"
              },
              barThickness: 10,
              stacked: true
            }
          ],
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                stepSize: 20,
                fontColor: "#696969",
                callback: function(label, index, labels) {
                  return label + " %";
                }
              },
              gridLines: {
                color: "#E6F2F9",
                zeroLineWidth: 0,
                zeroLineColor: "rgba(0,0,0,0)",
                borderDash: [2, 4, 3, 2],
                borderDashOffset: 3
              },
              stacked: true
            }
          ]
        }
      },

      retentionData: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "July",
          "Aug",
          "Sept",
          "Oct",
          "Nov"
        ],
        datasets: [
          {
            borderColor: "#7FCEFF",
            borderWidth: 2,
            pointBackgroundColor: "#7FCEFF",
            pointBorderColor: "white",
            pointRadius: 4,
            pointHoverBackgroundColor: "white",
            pointHoverBorderColor: "#7FCEFF",
            pointHoverRadius: 7,
            pointHitRadius: 6,
            fill: false,
            label: "Retention",
            data: [80, 40, 25, 20, 18, 17, 16, 15, 15, 15, 15, 14]
          }
        ]
      },

      retentionOptions: {
        legend: {
          display: false,
          labels: {
            boxWidth: 80,
            fontColor: "#696969"
          }
        },
        tooltips: {
          displayColors: false,
          borderColor: "#E6F2F9",
          borderWidth: 1,
          backgroundColor: "white",
          titleFontColor: "#696969",
          titleSpacing: 10,
          titleFontSize: 15,
          bodyFontColor: "#696969",
          bodyFontSize: 11,
          xPadding: 20,
          yPadding: 20
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 10,
                fontColor: "#696969"
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                stepSize: 20,
                max: 100,
                fontColor: "#696969",
                beginAtZero: true,
                callback: function(label, index, labels) {
                  return label + " %";
                }
              },
              gridLines: {
                color: "#E6F2F9",
                zeroLineWidth: 0,
                zeroLineColor: "rgba(0,0,0,0)",
                borderDash: [2, 4, 3, 2],
                borderDashOffset: 3
              }
            }
          ]
        }
      },

      idleData: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "July",
          "Aug",
          "Sept",
          "Oct",
          "Nov"
        ], // responsible for how many bars are gonna show on the chart
        datasets: [
          {
            label: "Good, Moderate or Poor Health",
            data: [20, 34, 53, 23, 40, 23, 43, 23, 53, 23, 44, 55],
            backgroundColor: "white",
            borderColor: "#7FCEFF",
            borderWidth: 1
          },
          {
            label: "Idle Customers",
            data: [12, 23, 24, 12, 12, 12, 24, 10, 12, 17, 20, 10],
            backgroundColor: "#7FCEFF"
          }
        ]
      },

      idleOptions: {
        legend: {
          display: false
        },
        tooltips: {
          displayColors: false,
          borderColor: "#E6F2F9",
          borderWidth: 1,
          backgroundColor: "white",
          titleFontColor: "#696969",
          titleSpacing: 10,
          titleFontSize: 15,
          bodyFontColor: "#696969",
          bodyFontSize: 11,
          xPadding: 20,
          yPadding: 20
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 10,
                fontColor: "#696969"
              },
              gridLines: {
                display: false
              },
              barThickness: 10,
              stacked: true
            }
          ],
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                stepSize: 20,
                fontColor: "#696969",
                callback: function(label, index, labels) {
                  return label + " %";
                }
              },
              gridLines: {
                color: "#E6F2F9",
                zeroLineWidth: 0,
                zeroLineColor: "rgba(0,0,0,0)",
                borderDash: [2, 4, 3, 2],
                borderDashOffset: 3
              },
              stacked: true
            }
          ]
        },
        plugins: {
          stacked100: { enable: true }
        }
      },

      churnData: {
        labels: this.returnChurnDates(),
        datasets: [
          {
            borderColor: "#7FCEFF",
            borderWidth: 2,
            pointBackgroundColor: "#7FCEFF",
            pointBorderColor: "white",
            pointRadius: 4,
            pointHoverBackgroundColor: "white",
            pointHoverBorderColor: "#7FCEFF",
            pointHoverRadius: 7,
            pointHitRadius: 6,
            fill: false,
            label: "Churn",
            data: this.returnChurnData()
          }
        ]
      },

      churnOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            boxWidth: 80,
            fontColor: "#696969"
          }
        },
        tooltips: {
          displayColors: false,
          borderColor: "#E6F2F9",
          borderWidth: 1,
          backgroundColor: "white",
          titleFontColor: "#696969",
          titleSpacing: 10,
          titleFontSize: 15,
          bodyFontColor: "#696969",
          bodyFontSize: 11,
          xPadding: 20,
          yPadding: 20
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: 10,
                fontColor: "#696969"
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                stepSize: 2,
                max: 10,
                fontColor: "#696969",
                beginAtZero: true,
                callback: function(label, index, labels) {
                  return label + " %";
                }
              },
              gridLines: {
                color: "#E6F2F9",
                zeroLineWidth: 0,
                zeroLineColor: "rgba(0,0,0,0)",
                borderDash: [2, 4, 3, 2],
                borderDashOffset: 3
              }
            }
          ]
        }
      },

      riskDoughnut: {
        datasets: [
          {
            data: this.doughnutData().poor,
            borderColor: ["#FF9179", "#FF9179"],
            backgroundColor: ["#FF9179", "white"]
          }
        ],

        labels: ["Other", "At Risk of churning"]
      },

      medDoughnut: {
        datasets: [
          {
            data: this.doughnutData().moderate,
            borderColor: ["#FAE17E", "#FAE17E"],
            backgroundColor: ["#FAE17E", "white"]
          }
        ],

        labels: ["Other", "Could churn soon"]
      },

      goodDoughnut: {
        datasets: [
          {
            data: this.doughnutData().high,
            borderColor: ["#45EAAF", "#45EAAF"],
            backgroundColor: ["#45EAAF", "white"]
          }
        ],

        labels: ["Other", "Not at risk of churning"]
      },

      doughnutOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 87,
        legend: {
          display: false
        }
      }
    });
  }

  componentDidUpdate() {
    if (this.props.data && !this.props.data.loading && !this.state) {
      this.setState({
        account_app: {
          activeCustomerCount: this.activeCustomerCount(),
          arpu: this.formattedARPU(),
          customer_churn: this.formattedCustomerChurn(),
          mrr: this.formattedMRR(),
          good_health_customer_count: this.good_health_customer_count(),
          good_health_customer_percent: this.good_health_customer_percent(),
          moderate_health_customer_count: this.moderate_health_customer_count(),
          poor_health_customer_count: this.poor_health_customer_count(),
          idle_customer_count: this.activeCustomerCount()
        }
      });
      this.setChartData();
    }
  }

  returnChurnData = () => {
    let churnSeriesData = [];

    this.props.data.account.account_apps[0].customer_churn_series.map(churn => {
      churnSeriesData.push(churn.churn * 100);
    });

    return churnSeriesData;
  };

  returnChurnDates = () => {
    let churnSeriesDates = [];

    this.props.data.account.account_apps[0].customer_churn_series.map(churn => {
      churnSeriesDates.push(moment(churn.date).format("MMMM"));
    });

    return churnSeriesDates;
  };

  doughnutData = () => {
    let acct = this.props.data.account.account_apps[0];
    let total =
      acct.poor_health_customer_count +
      acct.moderate_health_customer_count +
      acct.good_health_customer_count;

    let result = {
      poor: [
        acct.poor_health_customer_count,
        total - acct.poor_health_customer_count
      ],
      moderate: [
        acct.moderate_health_customer_count,
        total - acct.moderate_health_customer_count
      ],
      high: [
        acct.good_health_customer_count,
        total - acct.good_health_customer_count
      ]
    };

    return result;
  };

  formattedARPU() {
    let arpu = 0.0;
    if (this.props.data.account.account_apps[0].arpu) {
      arpu = this.props.data.account.account_apps[0].arpu;
    }

    return (
      "$" +
      arpu.toLocaleString("USD", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
    );
  }

  formattedCustomerChurn() {
    let churn = 0.0;
    if (this.props.data.account.account_apps[0].customer_churn) {
      churn = this.props.data.account.account_apps[0].customer_churn;
    }

    return churn.toLocaleString("en-US", {
      style: "percent",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
  }

  formattedMRR() {
    let mrr = 0.0;
    if (this.props.data.account.account_apps[0].mrr) {
      mrr = this.props.data.account.account_apps[0].mrr;
    }

    return (
      "$" +
      mrr.toLocaleString("USD", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
    );
  }

  activeCustomerCount() {
    return this.props.data.account.account_apps[0].activeCustomerCount;
  }

  good_health_customer_count() {
    return this.props.data.account.account_apps[0].good_health_customer_count;
  }

  good_health_customer_percent() {
    let percent =
      this.good_health_customer_count() / this.activeCustomerCount();
    return percent;
  }

  moderate_health_customer_count() {
    return this.props.data.account.account_apps[0]
      .moderate_health_customer_count;
  }

  poor_health_customer_count() {
    return this.props.data.account.account_apps[0].poor_health_customer_count;
  }

  render() {
    console.log("props are -> ", this.props);

    if (!this.state) {
      return <Loader />;
    } else {
      return (
        <div>
          <Split style={{ height: "200px" }}>
            <Box
              justify="center"
              pad="small"
              style={{ display: "block", overflow: "auto" }}
            >
              <StatBox
                mr
                color={"#FF9179"}
                stat={this.state.account_app.activeCustomerCount}
                title={"Customers"}
              />
              <StatBox
                color={"#45EAAF"}
                stat={this.state.account_app.arpu}
                title={"ARPU"}
              />
              <StatBox
                mr
                color={"#FF9179"}
                stat={this.state.account_app.customer_churn}
                title={"Current Churn"}
              />
              <StatBox
                color={"#45EAAF"}
                stat={this.state.account_app.mrr}
                title={"MRR"}
              />
            </Box>
            <Box
              justify="center"
              direction="row"
              pad="small"
              style={{
                margin: "12px",
                height: "169px",
                borderRadius: "5px",
                boxShadow: "0 2px 12px 0 rgba(218,218,218,0.50)"
              }}
            >
              <Box
                justify="center"
                direction="row"
                style={{ width: "33%", position: "relative" }}
                pad="small"
              >
                <DoughnutLabel>
                  <DoughnutNum>
                    {this.state.account_app.poor_health_customer_count}
                  </DoughnutNum>
                  <DoughnutCopy>High risk of leaving</DoughnutCopy>
                </DoughnutLabel>
                <Doughnut
                  options={this.state.doughnutOptions}
                  data={this.state.riskDoughnut}
                />
              </Box>
              <Box
                justify="center"
                direction="row"
                style={{ width: "33%", position: "relative" }}
                pad="small"
              >
                <DoughnutLabel>
                  <DoughnutNum>
                    {this.state.account_app.moderate_health_customer_count}
                  </DoughnutNum>
                  <DoughnutCopy>Moderate risk of leaving</DoughnutCopy>
                </DoughnutLabel>
                <Doughnut
                  options={this.state.doughnutOptions}
                  data={this.state.medDoughnut}
                />
              </Box>
              <Box
                justify="center"
                direction="row"
                style={{ width: "33%", position: "relative" }}
                pad="small"
              >
                <DoughnutLabel>
                  <DoughnutNum>
                    {this.state.account_app.good_health_customer_count}
                  </DoughnutNum>
                  <DoughnutCopy>In Good Health</DoughnutCopy>
                </DoughnutLabel>
                <Doughnut
                  options={this.state.doughnutOptions}
                  data={this.state.goodDoughnut}
                />
              </Box>
            </Box>
          </Split>
          <Box
            justify="center"
            pad="medium"
            style={{
              boxShadow: "0 2px 12px 0 rgba(218,218,218,0.50)",
              margin: "12px",
              borderRadius: "5px"
            }}
          >
            <Box pad="small">
              <ChartTitle style={{ float: "left" }}>Churn</ChartTitle>
              {/*<DateRange />*/}
              <div style={{ height: "250px", marginBottom: "30px" }}>
                <Line
                  options={this.state.churnOptions}
                  data={this.state.churnData}
                  redraw
                />
              </div>
            </Box>
            <Split fixed={false}>
              <Box pad="small">
                <ChartTitle>Retention</ChartTitle>
                {/*<DateRange />*/}
                <Line
                  options={this.state.retentionOptions}
                  data={this.state.retentionData}
                  redraw
                />
              </Box>
              <Box pad="small">
                <ChartTitle>Idle Customers</ChartTitle>
                {/*<DateRange />*/}
                <Bar
                  options={this.state.idleOptions}
                  data={this.state.idleData}
                  redraw
                />
              </Box>
            </Split>
          </Box>
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: () => push("/customers")
    },
    dispatch
  );

const getAppDataQuery = gql`
  query {
    account {
      account_apps {
        id
        mrr
        arpu
        activeCustomerCount
        customer_churn_series {
          churn
          date
        }
        customer_churn
        good_health_customer_count
        moderate_health_customer_count
        poor_health_customer_count
        idle_customer_count
      }
    }
  }
`;

const DashboardFlow = flow(
  connect(mapDispatchToProps),
  compose(graphql(getAppDataQuery))
)(Dashboard);

export default DashboardFlow;



// WEBPACK FOOTER //
// ./src/containers/loggedIn/dashboard.js